import { useQuery } from '@tanstack/react-query';

import { HOST_MB } from '@/lib/constants';
import { apiV2Public, getData } from '@/lib/api/client-v2';
import { queryKeys } from '@/lib/query-keys';
import { PUBLIC_ENDPOINTS } from '@/types/api/endpoints';
import type { Whitelabel } from '@/types/api/user';

import { useCurrentUser } from '@/hooks/api/use-user';

/** Marque blanche de l'utilisateur connecté. */
export const useWhitelabel = () => {
    const { whitelabel } = useCurrentUser();

    return useQuery({
        queryKey: queryKeys.whitelabel(whitelabel),
        queryFn: () => getData<Whitelabel>(PUBLIC_ENDPOINTS.whitelabel(whitelabel as string | number), undefined, apiV2Public),
        enabled: whitelabel !== undefined && whitelabel !== null && whitelabel !== '',
        staleTime: Infinity,
    });
};

/**
 * Marque blanche de l'hôte courant, lisible avant connexion (écrans de login).
 *
 * `retryOnMount: false` : l'écran de login attend cette requête derrière un spinner puis monte
 * ses enfants, qui l'observent aussi. Sans ce drapeau, une erreur relancerait la requête au
 * montage, la repasserait en `pending` (aucune donnée en cache), réafficherait le spinner… en boucle.
 */
export const useWhitelabelByHost = () =>
    useQuery({
        queryKey: queryKeys.whitelabelByHost(HOST_MB),
        queryFn: () => getData<Whitelabel>(PUBLIC_ENDPOINTS.whitelabelByBelair(HOST_MB), undefined, apiV2Public),
        staleTime: Infinity,
        retryOnMount: false,
    });
